import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as DeliveryDatesActions from '../actions/offers.delivery.dates.action';
import { OfferDeliveryDates } from '@dgx-pr-spa/shared/util';

export type OffersDeliveryDatesState = EntityState<OfferDeliveryDates>;

export const adapter: EntityAdapter<OfferDeliveryDates> = createEntityAdapter({
  selectId: (obj) => {
    return `${obj.supplier_id}/${obj.cat_num}`;
  },
});

export const initialState: OffersDeliveryDatesState = adapter.getInitialState({
  // additional entity state properties
});

const userReducer = createReducer(
  initialState,
  on(DeliveryDatesActions.addOfferDeliveryDates, (state, { payload }) => {
    return adapter.addOne(payload, state);
  })
);

export function reducer(
  state: OffersDeliveryDatesState | undefined,
  action: Action
) {
  return userReducer(state, action);
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectOffersDeliveryDatesIds = selectIds;
export const selectOffersDeliveryDatesEntities = selectEntities;
export const selectOffersDeliveryDates = selectAll;
